import { Input as IdskInput } from '@mc-ui/idsk-react-components';

import { withReactHookForm } from '../hoc/withReactHookForm';

export const Input = withReactHookForm(IdskInput);
